import { State } from "processEditor/model/State";
import * as _ from "lodash";
import { ValidationError, ValidationErrorType } from "processEditor/model/ValidationData";
import { ElementType } from "processEditor/model/IProcessData";
import { addNameValidationError } from "../ValidateProcess";
import { Triggers } from "processEditor/model/ITriggerData";

export default function ({ validationErrors, state }: IManualTriggerValidatorProps) {
    if (state.process.manualTrigger.some((parameter) => parameter.isInvalid)) { // Manual trigger parameters should be valid
        const manualTrigger = _.find(state.elements, (s) => s.type === ElementType.Start && s.selectedTypeId === Triggers.ManualTrigger.triggerType);
        if (manualTrigger) {
            addNameValidationError(validationErrors, ValidationErrorType.InvalidKeyName, manualTrigger.id);
        }
    }
}

interface IManualTriggerValidatorProps {
    state: State
    validationErrors: ValidationError[];
}